module.exports = __webpack_public_path__ + "static/lincoln-a099a92d4ddb013196089d6459a58731.jpg";